export default "__VITE_ASSET__b52ed553__"